import { IconButton, type IconButtonProps, useTheme } from '@mui/material';

import { gray300Color, gray400Color } from '../tokenColorTemporary';
import useAIDTMediaQuery from '../../hooks/useAIDTMediaQuery';
import type { ReactNode } from 'react';

export interface EliceIconButtonProps extends IconButtonProps {
  children: ReactNode;
  backgroundColor?: string;
  width?: number | string;
  height?: number | string;
  borderRadius?: number;
}
const EliceIconButton = ({
  children,
  disabled,
  backgroundColor,
  width,
  height,
  borderRadius,
  ...rest
}: EliceIconButtonProps) => {
  const theme = useTheme();
  const { isMiniTablet } = useAIDTMediaQuery();
  return (
    <IconButton
      disabled={disabled}
      style={{
        flexShrink: 0,
        height: height ?? '3.5rem',
        width: width ?? '3.5rem',
        boxSizing: 'border-box',
        backgroundColor: disabled ? gray300Color : backgroundColor ? backgroundColor : theme.palette.primary.main,
        borderRadius: borderRadius ?? '1rem',
        padding: isMiniTablet ? 8 : 10,
        color: disabled ? gray400Color : theme.palette.primary.light,
      }}
      {...rest}
    >
      {children}
    </IconButton>
  );
};

export default EliceIconButton;
